let cache;

function translations() {
  if (cache) {
    return cache;
  }

  const el = document.getElementById('i18n-translations');
  if (!el) {
    return {};
  }

  cache = JSON.parse(el.textContent);
  return cache;
}

export function t(key, interpolations = {}) {
  const value = translations()[key];

  if (value == null) {
    return key;
  }

  if (Array.isArray(value)) {
    return value;
  }

  return String(value).replace(/%\{(\w+)\}/g, (_, name) =>
    interpolations[name] == null ? '' : String(interpolations[name]),
  );
}
